;(window.HB = window.HB || {}).isVisible = function (el) {
  if (!el) return false
  const node = el.nodeType ? el : el[0]
  if (!node) return false
  return !!(
    node.offsetWidth ||
    node.offsetHeight ||
    node.getClientRects().length
  )
}
